import type { AiClient } from "@features/api/AiApi";
import type {
  DailyMarketLanguage,
  DailyMarketReportDTO,
} from "@/src/components/DailyMarketSummary/types";

export async function fetchDailyMarketSummaryReport(
  aiApi: AiClient<any>,
  language: DailyMarketLanguage,
): Promise<DailyMarketReportDTO | null> {
  const res = await aiApi.dailyMarketSummary.getDailyMarketSummary({
    language,
  });
  const report = res.data?.data;
  if (!report || !report.title || !report.content) {
    return null;
  }
  return {
    date: report.date ?? "",
    title: report.title,
    content: report.content,
    language: (report.language as DailyMarketLanguage) || language,
  };
}

/** Public REST report date only — used by external unread checks */
export async function fetchDailyMarketReportDate(
  aiApi: AiClient<any>,
  language: DailyMarketLanguage,
): Promise<string | null> {
  const report = await fetchDailyMarketSummaryReport(aiApi, language);
  return report?.date ?? null;
}
